{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "effects": [
    {
      "key": "special_armour_kinetic",
      "id": 144,
      "name": "Angled Plating",
      "description": "Custom angling of plates at critical points along the ship's hull make projectile strikes more likely to glance, reducing the impact of kinetic damage at the cost of structural integrity.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "zirconium",
          "name": "Zirconium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_hullreinforcement_kinetic",
      "id": 148,
      "name": "Angled Plating",
      "description": "Custom angling of plates at critical points along the ship's hull make projectile strikes more likely to glance, reducing the impact of kinetic damage at the cost of reducing structural integrity benefits.",
      "ingredients": [
        {
          "materialKey": "carbon",
          "name": "Carbon",
          "size": 5
        },
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "temperedalloys",
          "name": "Tempered Alloys",
          "size": 5
        },
        {
          "materialKey": "zirconium",
          "name": "Zirconium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_auto_loader",
      "id": 0,
      "name": "Auto loader",
      "description": "An experimental upgrade that automatically reloads the weapon, even when firing.",
      "ingredients": [
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "mechanicalcomponents",
          "name": "Mechanical Components",
          "size": 3
        },
        {
          "materialKey": "mechanicalequipment",
          "name": "Mechanical Equipment",
          "size": 4
        }
      ]
    },
    {
      "key": "special_shieldbooster_explosive",
      "id": 153,
      "name": "Blast Block",
      "description": "Advanced field resonation patterns increase resistance to explosive damage, at the cost of overall shield strength.",
      "ingredients": [
        {
          "materialKey": "heatdispersionplate",
          "name": "Heat Dispersion Plate",
          "size": 3
        },
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "inconsistentshieldsoakanalysis",
          "name": "Inconsistent Shield Soak Analysis",
          "size": 5
        },
        {
          "materialKey": "selenium",
          "name": "Selenium",
          "size": 2
        }
      ]
    },
    {
      "key": "special_shieldcell_oversized",
      "id": 134,
      "name": "Boss Cells",
      "description": "Oversized cells offer increased cell strength at cost of an increased spin up time.",
      "ingredients": [
        {
          "materialKey": "chemicalstorageunits",
          "name": "Chemical Storage Units",
          "size": 5
        },
        {
          "materialKey": "chromium",
          "name": "Chromium",
          "size": 3
        },
        {
          "materialKey": "polymercapacitors",
          "name": "Polymer Capacitors",
          "size": 1
        }
      ]
    },
    {
      "key": "special_choke_canister",
      "id": 1,
      "name": "Choke canister",
      "description": null,
      "ingredients": []
    },
    {
      "key": "special_powerdistributor_capacity",
      "id": 128,
      "name": "Cluster Capacitors",
      "description": "Additional capacitor arrays allow the power distributor to store more energy at the cost of a slower charging rate.",
      "ingredients": [
        {
          "materialKey": "cadmium",
          "name": "Cadmium",
          "size": 1
        },
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        }
      ]
    },
    {
      "key": "special_concordant_sequence",
      "id": 2,
      "name": "Concordant sequence",
      "description": "A modification that causes weapon strikes to temporarily enhance the regeneration rate of a wingman's shield, at the cost of increased heat generation.",
      "ingredients": [
        {
          "materialKey": "focuscrystals",
          "name": "Focus Crystals",
          "size": 5
        },
        {
          "materialKey": "modifiedembeddedfirmware",
          "name": "Modified Embedded Firmware",
          "size": 3
        },
        {
          "materialKey": "zirconium",
          "name": "Zirconium",
          "size": 1
        }
      ]
    },
    {
      "key": "special_corrosive_shell",
      "id": 3,
      "name": "Corrosive shell",
      "description": "Experimental rounds that temporarily weaken hull hardness and increase all damage taken, at the cost of reduced ammo capacity.",
      "ingredients": [
        {
          "materialKey": "arsenic",
          "name": "Arsenic",
          "size": 3
        },
        {
          "materialKey": "chemicalstorageunits",
          "name": "Chemical Storage Units",
          "size": 5
        },
        {
          "materialKey": "precipitatedalloys",
          "name": "Precipitated Alloys",
          "size": 4
        }
      ]
    },
    {
      "key": "special_blinding_shell",
      "id": 4,
      "name": "Dazzle shell",
      "description": "Experimental shells that temporarily reduce a target's sensor acuity upon impact.",
      "ingredients": [
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 5
        },
        {
          "materialKey": "manganese",
          "name": "Manganese",
          "size": 4
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        }
      ]
    },
    {
      "key": "special_fsd_fuelcapacity",
      "id": 119,
      "name": "Deep Charge",
      "description": "Toughened FSD power conduits and a reinforced charging field increase the amount of fuel injected when charging, allowing larger jumps at the cost of increased power draw.",
      "ingredients": [
        {
          "materialKey": "atypicaldisruptedwakeechoes",
          "name": "Atypical Disrupted Wake Echoes",
          "size": 5
        },
        {
          "materialKey": "eccentrichyperspacetrajectories",
          "name": "Eccentric Hyperspace Trajectories",
          "size": 1
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 3
        }
      ]
    },
    {
      "key": "special_armour_chunky",
      "id": 146,
      "name": "Deep Plating",
      "description": "Increased depth of plating increases the ship's overall structural integrity, at the cost of resistance against all types of damage.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "mechanicalequipment",
          "name": "Mechanical Equipment",
          "size": 3
        },
        {
          "materialKey": "molybdenum",
          "name": "Molybdenum",
          "size": 2
        }
      ]
    },
    {
      "key": "special_hullreinforcement_chunky",
      "id": 150,
      "name": "Deep Plating",
      "description": "Increased depth of plating increases the ship's overall structural integrity, at the cost of resistance against all types of damage.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "molybdenum",
          "name": "Molybdenum",
          "size": 3
        },
        {
          "materialKey": "ruthenium",
          "name": "Ruthenium",
          "size": 2
        }
      ]
    },
    {
      "key": "special_dispersal_field",
      "id": 5,
      "name": "Dispersal field",
      "description": "Experimental upgrade that causes successful strikes to temporarily confuse all gimbal and turret hardpoints on the target, at the cost of direct damage potential.",
      "ingredients": [
        {
          "materialKey": "archivedemissiondata",
          "name": "Irregular Emission Data",
          "size": 5
        },
        {
          "materialKey": "conductivecomponents",
          "name": "Conductive Components",
          "size": 5
        },
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 5
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_shield_toughened",
      "id": 112,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "vanadium",
          "name": "Vanadium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_engine_toughened",
      "id": 117,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "fedproprietarycomposites",
          "name": "Proprietary Composites",
          "size": 1
        },
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 3
        },
        {
          "materialKey": "iron",
          "name": "Iron",
          "size": 5
        }
      ]
    },
    {
      "key": "special_fsd_toughened",
      "id": 121,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "atypicaldisruptedwakeechoes",
          "name": "Atypical Disrupted Wake Echoes",
          "size": 5
        },
        {
          "materialKey": "configurablecomponents",
          "name": "Configurable Components",
          "size": 1
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 3
        }
      ]
    },
    {
      "key": "special_powerplant_toughened",
      "id": 126,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "fedproprietarycomposites",
          "name": "Proprietary Composites",
          "size": 1
        },
        {
          "materialKey": "gridresistors",
          "name": "Grid Resistors",
          "size": 5
        },
        {
          "materialKey": "vanadium",
          "name": "Vanadium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_powerdistributor_toughened",
      "id": 131,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "fedproprietarycomposites",
          "name": "Proprietary Composites",
          "size": 1
        },
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        }
      ]
    },
    {
      "key": "special_shieldcell_toughened",
      "id": 136,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "chemicalstorageunits",
          "name": "Chemical Storage Units",
          "size": 5
        },
        {
          "materialKey": "chromium",
          "name": "Chromium",
          "size": 3
        },
        {
          "materialKey": "yttrium",
          "name": "Yttrium",
          "size": 1
        }
      ]
    },
    {
      "key": "special_weapon_toughened",
      "id": 141,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "vanadium",
          "name": "Vanadium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_shieldbooster_toughened",
      "id": 155,
      "name": "Double Braced",
      "description": "Additional, hardened supports and bracing further improve module survivability.",
      "ingredients": [
        {
          "materialKey": "distortedshieldcyclerecordings",
          "name": "Distorted Shield Cycle Recordings",
          "size": 5
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 3
        },
        {
          "materialKey": "shieldemitters",
          "name": "Shield Emitters",
          "size": 3
        }
      ]
    },
    {
      "key": "special_engine_overloaded",
      "id": 116,
      "name": "Drag Drives",
      "description": "Removal of safety protocols in controller software to increase drive thrust output at the cost of additional heat generation.",
      "ingredients": [
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 3
        },
        {
          "materialKey": "iron",
          "name": "Iron",
          "size": 5
        },
        {
          "materialKey": "securityfirmwarepatch",
          "name": "Security Firmware Patch",
          "size": 1
        }
      ]
    },
    {
      "key": "special_drag_munitions",
      "id": 7,
      "name": "Drag munitions",
      "description": "Experimental munitions that disrupt engine exhaust flow on the target, temporarily preventing ENG power distribution from increasing thrust.",
      "ingredients": [
        {
          "materialKey": "carbon",
          "name": "Carbon",
          "size": 5
        },
        {
          "materialKey": "gridresistors",
          "name": "Grid Resistors",
          "size": 5
        },
        {
          "materialKey": "molybdenum",
          "name": "Molybdenum",
          "size": 5
        }
      ]
    },
    {
      "key": "special_engine_haulage",
      "id": 115,
      "name": "Drive Distributors",
      "description": "Enhanced fuel and thrust balancing across the drives to improve mass curve efficiency.",
      "ingredients": [
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 3
        },
        {
          "materialKey": "iron",
          "name": "Iron",
          "size": 5
        },
        {
          "materialKey": "securityfirmwarepatch",
          "name": "Security Firmware Patch",
          "size": 1
        }
      ]
    },
    {
      "key": "special_emissive_munitions",
      "id": 8,
      "name": "Emissive munitions",
      "description": "Experimental upgrade that causes strikes to envelope the target in energetic particles, significantly amplifying its signature, at the cost of increasing heat generation for the attacker.",
      "ingredients": [
        {
          "materialKey": "emissiondata",
          "name": "Unexpected Emission Data",
          "size": 3
        },
        {
          "materialKey": "heatexchangers",
          "name": "Heat Exchangers",
          "size": 3
        },
        {
          "materialKey": "manganese",
          "name": "Manganese",
          "size": 3
        },
        {
          "materialKey": "mechanicalequipment",
          "name": "Mechanical Equipment",
          "size": 4
        }
      ]
    },
    {
      "key": "special_shield_regenerative",
      "id": 106,
      "name": "Fast Charge",
      "description": "High speed charging units increase shield regeneration rate when active and reforming, at the cost of slightly weaker resistance versus all forms of damage.",
      "ingredients": [
        {
          "materialKey": "compoundshielding",
          "name": "Compound Shielding",
          "size": 3
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_feedback_cascade_cooled",
      "id": 100,
      "name": "Feedback Cascade",
      "description": "Rail slug energy charging mechanism, designed to interfere with shield cell operation. Strikes to a target deploying a shield cell will damage the shield cell bank and reduce shield restoration, at the cost of reduced damage from smaller rounds.",
      "ingredients": [
        {
          "materialKey": "filamentcomposites",
          "name": "Filament Composites",
          "size": 5
        },
        {
          "materialKey": "opensymmetrickeys",
          "name": "Open Symmetric Keys",
          "size": 5
        },
        {
          "materialKey": "shieldemitters",
          "name": "Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_feedback_cascade",
      "id": 9,
      "name": "Feedback cascade (Legacy)",
      "description": "Rail slug energy charging mechanism, designed to interfere with shield cell operation. Strikes to a target deploying a shield cell will damage the shield cell bank and reduce shield restoration, at the cost of reduced damage from smaller rounds.",
      "ingredients": []
    },
    {
      "key": "special_powerdistributor_efficient",
      "id": 130,
      "name": "Flow Control",
      "description": "Advanced software and internal sensors regulate energy flow more efficiently, reducing module power draw.",
      "ingredients": [
        {
          "materialKey": "conductivepolymers",
          "name": "Conductive Polymers",
          "size": 1
        },
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        }
      ]
    },
    {
      "key": "special_shieldcell_efficient",
      "id": 135,
      "name": "Flow Control",
      "description": "Advanced software and internal sensors regulate energy flow more efficiently, reducing module power draw.",
      "ingredients": [
        {
          "materialKey": "chemicalstorageunits",
          "name": "Chemical Storage Units",
          "size": 5
        },
        {
          "materialKey": "chromium",
          "name": "Chromium",
          "size": 3
        },
        {
          "materialKey": "conductivepolymers",
          "name": "Conductive Polymers",
          "size": 1
        }
      ]
    },
    {
      "key": "special_weapon_efficient",
      "id": 140,
      "name": "Flow Control",
      "description": "Advanced software and internal sensors regulate energy flow more efficiently, reducing module power draw.",
      "ingredients": [
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 3
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "modifiedembeddedfirmware",
          "name": "Modified Embedded Firmware",
          "size": 1
        }
      ]
    },
    {
      "key": "special_shieldbooster_efficient",
      "id": 154,
      "name": "Flow Control",
      "description": "Advanced software and internal sensors regulate energy flow more efficiently, reducing module power draw.",
      "ingredients": [
        {
          "materialKey": "focuscrystals",
          "name": "Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "inconsistentshieldsoakanalysis",
          "name": "Inconsistent Shield Soak Analysis",
          "size": 5
        },
        {
          "materialKey": "niobium",
          "name": "Niobium",
          "size": 3
        },
        {
          "materialKey": "securityfirmwarepatch",
          "name": "Security Firmware Patch",
          "size": 3
        }
      ]
    },
    {
      "key": "special_shield_kinetic",
      "id": 111,
      "name": "Force Block",
      "description": "Enlarged projection nodes increase resistance to kinetic damage, at the cost of overall shield strength.",
      "ingredients": [
        {
          "materialKey": "decodedemissiondata",
          "name": "Decoded Emission Data",
          "size": 1
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 5
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_shieldbooster_kinetic",
      "id": 152,
      "name": "Force Block",
      "description": "Enlarged projection nodes increase resistance to kinetic damage, at the cost of overall shield strength.",
      "ingredients": [
        {
          "materialKey": "aberrantshieldpatternanalysis",
          "name": "Aberrant Shield Pattern Analysis",
          "size": 2
        },
        {
          "materialKey": "shieldingsensors",
          "name": "Shielding Sensors",
          "size": 3
        },
        {
          "materialKey": "unidentifiedscanarchives",
          "name": "Unidentified Scan Archives",
          "size": 5
        }
      ]
    },
    {
      "key": "special_force_shell",
      "id": 10,
      "name": "Force shell",
      "description": "A modification to allow firing of low explosive shells, designed to generate a propelling blast. Strikes to a target are capable of forcing ships off course, at the cost of shot accuracy.",
      "ingredients": [
        {
          "materialKey": "heatconductionwiring",
          "name": "Heat Conduction Wiring",
          "size": 3
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "phasealloys",
          "name": "Phase Alloys",
          "size": 3
        },
        {
          "materialKey": "zinc",
          "name": "Zinc",
          "size": 5
        }
      ]
    },
    {
      "key": "special_fsd_interrupt",
      "id": 33,
      "name": "FSD interrupt",
      "description": "Experimental munitions that cause the frame shift drive on the impacted ship to reboot, at the cost of reduced damage.",
      "ingredients": [
        {
          "materialKey": "anomalousfsdtelemetry",
          "name": "Anomalous FSD Telemetry",
          "size": 5
        },
        {
          "materialKey": "configurablecomponents",
          "name": "Configurable Components",
          "size": 3
        },
        {
          "materialKey": "mechanicalequipment",
          "name": "Mechanical Equipment",
          "size": 5
        },
        {
          "materialKey": "strangewakesolutions",
          "name": "Strange Wake Solutions",
          "size": 3
        }
      ]
    },
    {
      "key": "special_shield_health",
      "id": 108,
      "name": "Hi-Cap",
      "description": "Additional capacitors and projection nodes increase maximum shield strength, at the cost of increased power draw and SYS drain.",
      "ingredients": [
        {
          "materialKey": "conductivepolymers",
          "name": "Conductive Polymers",
          "size": 1
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_high_yield_shell",
      "id": 11,
      "name": "High yield shell",
      "description": "Modified munitions that convert a portion of damage to explosive, capable of hitting multiple internal modules if the attack breaches the hull, at the cost of a reduced fire rate.",
      "ingredients": [
        {
          "materialKey": "chemicalmanipulators",
          "name": "Chemical Manipulators",
          "size": 3
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "nickel",
          "name": "Nickel",
          "size": 5
        },
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 3
        }
      ]
    },
    {
      "key": "special_incendiary_rounds",
      "id": 12,
      "name": "Incendiary rounds",
      "description": "Modified ammo system capable of delivering superheated rounds, increasing damage and converting a large portion to thermal.",
      "ingredients": [
        {
          "materialKey": "heatconductionwiring",
          "name": "Heat Conduction Wiring",
          "size": 5
        },
        {
          "materialKey": "phasealloys",
          "name": "Phase Alloys",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        },
        {
          "materialKey": "sulphur",
          "name": "Sulphur",
          "size": 5
        }
      ]
    },
    {
      "key": "special_distortion_field",
      "id": 6,
      "name": "Inertial impact",
      "description": "Experimental upgrade that increases damage and converts half of it to kinetic, at the cost of introducing aiming jitter.",
      "ingredients": [
        {
          "materialKey": "atypicaldisruptedwakeechoes",
          "name": "Atypical Disrupted Wake Echoes",
          "size": 5
        },
        {
          "materialKey": "distortedshieldcyclerecordings",
          "name": "Distorted Shield Cycle Recordings",
          "size": 5
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 5
        }
      ]
    },
    {
      "key": "special_ion_disruptor",
      "id": 13,
      "name": "Ion disruptor",
      "description": "Experimental munitions capable of disrupting a target's drives, causing them to reboot.",
      "ingredients": [
        {
          "materialKey": "chemicaldistillery",
          "name": "Chemical Distillery",
          "size": 3
        },
        {
          "materialKey": "electrochemicalarrays",
          "name": "Electrochemical Arrays",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        },
        {
          "materialKey": "sulphur",
          "name": "Sulphur",
          "size": 5
        }
      ]
    },
    {
      "key": "special_armour_explosive",
      "id": 145,
      "name": "Layered Plating",
      "description": "Layers of advanced inert lining material within the ship's plating absorb and redistribute the force from explosive attacks, reducing damage of this type at the cost of overall structural integrity.",
      "ingredients": [
        {
          "materialKey": "heatconductionwiring",
          "name": "Heat Conduction Wiring",
          "size": 5
        },
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "niobium",
          "name": "Niobium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_hullreinforcement_explosive",
      "id": 149,
      "name": "Layered Plating",
      "description": "Layers of advanced inert lining material within the ship's plating absorb and redistribute the force from explosive attacks, reducing damage of this type at the cost of reducing structural integrity benefits.",
      "ingredients": [
        {
          "materialKey": "heatconductionwiring",
          "name": "Heat Conduction Wiring",
          "size": 5
        },
        {
          "materialKey": "shieldingsensors",
          "name": "Shielding Sensors",
          "size": 3
        },
        {
          "materialKey": "tungsten",
          "name": "Tungsten",
          "size": 3
        }
      ]
    },
    {
      "key": "special_shield_efficient",
      "id": 109,
      "name": "Lo-draw",
      "description": "Lightweight component swaps and smaller charging units reduce power draw and SYS drain, at the cost of overall shield effectiveness.",
      "ingredients": [
        {
          "materialKey": "conductivepolymers",
          "name": "Conductive Polymers",
          "size": 1
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_mass_lock_munition",
      "id": 14,
      "name": "Mass lock munition",
      "description": "Experimental warheads incorporating frame shift technology. Successful detonation significantly inhibits charging for supercruise.",
      "ingredients": [
        {
          "materialKey": "aberrantshieldpatternanalysis",
          "name": "Aberrant Shield Pattern Analysis",
          "size": 3
        },
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "mechanicalequipment",
          "name": "Mechanical Equipment",
          "size": 5
        }
      ]
    },
    {
      "key": "special_mass_lock",
      "id": 105,
      "name": "Mass Lock Munition",
      "description": "Experimental warheads incorporating frame shift technology. Successful detonation significantly inhibits charging for supercruise.",
      "ingredients": [
        {
          "materialKey": "aberrantshieldpatternanalysis",
          "name": "Aberrant Shield Pattern Analysis",
          "size": 3
        },
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "mechanicalequipment",
          "name": "Mechanical Equipment",
          "size": 5
        }
      ]
    },
    {
      "key": "special_fsd_heavy",
      "id": 120,
      "name": "Mass Manager",
      "description": "Complex software upgrade and internal sensor suite able to optimise frame shift operation by analysing and accounting for ship loadout. Increases optimised mass at the cost of module health.",
      "ingredients": [
        {
          "materialKey": "atypicaldisruptedwakeechoes",
          "name": "Atypical Disrupted Wake Echoes",
          "size": 5
        },
        {
          "materialKey": "eccentrichyperspacetrajectories",
          "name": "Eccentric Hyperspace Trajectories",
          "size": 1
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 3
        }
      ]
    },
    {
      "key": "special_powerplant_highcharge",
      "id": 124,
      "name": "Monstered",
      "description": "Oversized, reinforced components increase power output at the cost of increased mass.",
      "ingredients": [
        {
          "materialKey": "gridresistors",
          "name": "Grid Resistors",
          "size": 5
        },
        {
          "materialKey": "polymercapacitors",
          "name": "Polymer Capacitors",
          "size": 1
        },
        {
          "materialKey": "vanadium",
          "name": "Vanadium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_weapon_rateoffire",
      "id": 139,
      "name": "Multi-servos",
      "description": "Additional servomechanisms and controller software allow the weapon to safely fire at an increased rate, at the cost of increased power draw.",
      "ingredients": [
        {
          "materialKey": "conductivepolymers",
          "name": "Conductive Polymers",
          "size": 2
        },
        {
          "materialKey": "configurablecomponents",
          "name": "Configurable Components",
          "size": 2
        },
        {
          "materialKey": "focuscrystals",
          "name": "Focus Crystals",
          "size": 4
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        }
      ]
    },
    {
      "key": "special_shield_resistive",
      "id": 107,
      "name": "Multi-weave",
      "description": "Reinforced shield weave structures increase resistance versus all types of damage, at the cost of increased power draw and SYS drain.",
      "ingredients": [
        {
          "materialKey": "aberrantshieldpatternanalysis",
          "name": "Aberrant Shield Pattern Analysis",
          "size": 1
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_overload_munitions",
      "id": 15,
      "name": "Overload munitions",
      "description": "Experimental munitions that convert a portion of explosive damage to thermal.",
      "ingredients": [
        {
          "materialKey": "aberrantshieldpatternanalysis",
          "name": "Aberrant Shield Pattern Analysis",
          "size": 2
        },
        {
          "materialKey": "filamentcomposites",
          "name": "Filament Composites",
          "size": 5
        },
        {
          "materialKey": "germanium",
          "name": "Germanium",
          "size": 3
        },
        {
          "materialKey": "taggedencryptioncodes",
          "name": "Tagged Encryption Codes",
          "size": 4
        }
      ]
    },
    {
      "key": "special_weapon_damage",
      "id": 138,
      "name": "Oversized",
      "description": "Scaled up components and reinforced munitions housing allows the weapon to pack more of a punch, increasing damage at the cost of increased power draw.",
      "ingredients": [
        {
          "materialKey": "mechanicalcomponents",
          "name": "Mechanical Components",
          "size": 3
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "ruthenium",
          "name": "Ruthenium",
          "size": 1
        }
      ]
    },
    {
      "key": "special_penetrator_munitions",
      "id": 103,
      "name": "Penetrator Munitions",
      "description": "Experimental munitions capable of penetrating hull to damage internal modules.",
      "ingredients": [
        {
          "materialKey": "electrochemicalarrays",
          "name": "Electrochemical Arrays",
          "size": 3
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 5
        },
        {
          "materialKey": "zirconium",
          "name": "Zirconium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_penetrator_payload",
      "id": 16,
      "name": "Penetrator payload",
      "description": "Deep cut munitions are guaranteed to penetrate upon impact with hull and are capable of damaging multiple internal modules.",
      "ingredients": [
        {
          "materialKey": "anomalousbulkscandata",
          "name": "Anomalous Bulk Scan Data",
          "size": 5
        },
        {
          "materialKey": "mechanicalcomponents",
          "name": "Mechanical Components",
          "size": 3
        },
        {
          "materialKey": "selenium",
          "name": "Selenium",
          "size": 3
        },
        {
          "materialKey": "tungsten",
          "name": "Tungsten",
          "size": 3
        }
      ]
    },
    {
      "key": "special_deep_cut_payload",
      "id": 104,
      "name": "Penetrator Payload",
      "description": "Deep cut munitions are guaranteed to penetrate upon impact with hull and are capable of damaging multiple internal modules.",
      "ingredients": [
        {
          "materialKey": "anomalousbulkscandata",
          "name": "Anomalous Bulk Scan Data",
          "size": 5
        },
        {
          "materialKey": "mechanicalcomponents",
          "name": "Mechanical Components",
          "size": 3
        },
        {
          "materialKey": "selenium",
          "name": "Selenium",
          "size": 3
        },
        {
          "materialKey": "tungsten",
          "name": "Tungsten",
          "size": 3
        }
      ]
    },
    {
      "key": "special_phasing_sequence",
      "id": 17,
      "name": "Phasing sequence",
      "description": "Modulating burst fire system designed to defeat shielding. A small amount of damage is able to bleed through shields and attack the target's hull directly, at the cost of minor damage reduction.",
      "ingredients": [
        {
          "materialKey": "aberrantshieldpatternanalysis",
          "name": "Aberrant Shield Pattern Analysis",
          "size": 3
        },
        {
          "materialKey": "configurablecomponents",
          "name": "Configurable Components",
          "size": 3
        },
        {
          "materialKey": "focuscrystals",
          "name": "Focus Crystals",
          "size": 5
        },
        {
          "materialKey": "niobium",
          "name": "Niobium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_plasma_slug_cooled",
      "id": 102,
      "name": "Plasma Slug",
      "description": "Experimental upgrade allowing plasma slug ammo to be generated directly from ship fuel, at the cost of reduced damage.",
      "ingredients": [
        {
          "materialKey": "heatexchangers",
          "name": "Heat Exchangers",
          "size": 3
        },
        {
          "materialKey": "mercury",
          "name": "Mercury",
          "size": 4
        },
        {
          "materialKey": "modifiedembeddedfirmware",
          "name": "Modified Embedded Firmware",
          "size": 2
        },
        {
          "materialKey": "refinedfocuscrystals",
          "name": "Refined Focus Crystals",
          "size": 2
        }
      ]
    },
    {
      "key": "special_plasma_slug_pa",
      "id": 157,
      "name": "Plasma Slug",
      "description": "Experimental upgrade allowing plasma slug ammo to be generated directly from ship fuel, at the cost of reduced damage.",
      "ingredients": [
        {
          "materialKey": "heatexchangers",
          "name": "Heat Exchangers",
          "size": 3
        },
        {
          "materialKey": "mercury",
          "name": "Mercury",
          "size": 4
        },
        {
          "materialKey": "modifiedembeddedfirmware",
          "name": "Modified Embedded Firmware",
          "size": 2
        },
        {
          "materialKey": "refinedfocuscrystals",
          "name": "Refined Focus Crystals",
          "size": 2
        }
      ]
    },
    {
      "key": "special_plasma_slug",
      "id": 18,
      "name": "Plasma slug (Legacy)",
      "description": "Experimental upgrade allowing plasma slug ammo to be generated directly from ship fuel, at the cost of reduced damage.",
      "ingredients": []
    },
    {
      "key": "special_radiant_canister",
      "id": 19,
      "name": "Radiant Canister",
      "description": "Experimental munitions that apply significant heat to all targets caught in the blast radius. In addition, targets' sensors are temporarily disrupted, at the cost of ammo capacity.",
      "ingredients": [
        {
          "materialKey": "heatdispersionplate",
          "name": "Heat Dispersion Plate",
          "size": 4
        },
        {
          "materialKey": "phasealloys",
          "name": "Phase Alloys",
          "size": 3
        },
        {
          "materialKey": "polonium",
          "name": "Polonium",
          "size": 1
        }
      ]
    },
    {
      "key": "special_shieldcell_gradual",
      "id": 133,
      "name": "Recycling Cell",
      "description": "Uprated resonating coils maximise the amount of time the shield cell can remain active before depleting, at the cost of overall strength of the cell charge.",
      "ingredients": [
        {
          "materialKey": "chemicalstorageunits",
          "name": "Chemical Storage Units",
          "size": 5
        },
        {
          "materialKey": "chromium",
          "name": "Chromium",
          "size": 3
        },
        {
          "materialKey": "configurablecomponents",
          "name": "Configurable Components",
          "size": 1
        }
      ]
    },
    {
      "key": "special_armour_thermic",
      "id": 143,
      "name": "Reflective Plating",
      "description": "Surface coating of advanced formulas designed to reflect and dissipate thermal energy, at the cost of structural integrity.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "heatdispersionplate",
          "name": "Heat Dispersion Plate",
          "size": 3
        },
        {
          "materialKey": "thermicalloys",
          "name": "Thermic Alloys",
          "size": 2
        }
      ]
    },
    {
      "key": "special_hullreinforcement_thermic",
      "id": 147,
      "name": "Reflective Plating",
      "description": "Surface coating of advanced formulas designed to reflect and dissipate thermal energy, at the cost of reducing structural integrity benefits.",
      "ingredients": [
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "heatdispersionplate",
          "name": "Heat Dispersion Plate",
          "size": 3
        },
        {
          "materialKey": "thermicalloys",
          "name": "Thermic Alloys",
          "size": 2
        }
      ]
    },
    {
      "key": "special_regeneration_sequence",
      "id": 20,
      "name": "Regeneration sequence",
      "description": "Friend or Foe Beam modulation upgrade. When the beam strikes a wingman's shields its energy is regulated, regenerating the shield instead of damaging it.",
      "ingredients": [
        {
          "materialKey": "peculiarshieldfrequencydata",
          "name": "Peculiar Shield Frequency Data",
          "size": 1
        },
        {
          "materialKey": "refinedfocuscrystals",
          "name": "Refined Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "shieldingsensors",
          "name": "Shielding Sensors",
          "size": 4
        }
      ]
    },
    {
      "key": "special_reverberating_cascade",
      "id": 21,
      "name": "Reverberating cascade",
      "description": "Experimental munitions that overload shields on impact, directly damaging the shield generator.",
      "ingredients": [
        {
          "materialKey": "chromium",
          "name": "Chromium",
          "size": 4
        },
        {
          "materialKey": "configurablecomponents",
          "name": "Configurable Components",
          "size": 2
        },
        {
          "materialKey": "filamentcomposites",
          "name": "Filament Composites",
          "size": 4
        },
        {
          "materialKey": "scandatabanks",
          "name": "Classified Scan Databanks",
          "size": 3
        }
      ]
    },
    {
      "key": "special_scramble_spectrum",
      "id": 22,
      "name": "Scramble spectrum",
      "description": "Experimental upgrade that allows hull strikes to potentially trigger random malfunctions on the target.",
      "ingredients": [
        {
          "materialKey": "crystalshards",
          "name": "Crystal Shards",
          "size": 5
        },
        {
          "materialKey": "exceptionalscrambledemissiondata",
          "name": "Exceptional Scrambled Emission Data",
          "size": 5
        },
        {
          "materialKey": "shielddensityreports",
          "name": "Untypical Shield Scans",
          "size": 3
        }
      ]
    },
    {
      "key": "special_screening_shell",
      "id": 23,
      "name": "Screening shell",
      "description": "Modified firing and targeting mechanism, decreasing reload times and increasing effectiveness against munitions.",
      "ingredients": [
        {
          "materialKey": "distortedshieldcyclerecordings",
          "name": "Distorted Shield Cycle Recordings",
          "size": 5
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "modifiedconsumerfirmware",
          "name": "Modified Consumer Firmware",
          "size": 5
        },
        {
          "materialKey": "niobium",
          "name": "Niobium",
          "size": 2
        }
      ]
    },
    {
      "key": "special_shiftlock_canister",
      "id": 24,
      "name": "Shift-lock canister",
      "description": "Experimental munitions that cause all frame shift drives caught in the blast radius to reboot, at the cost of reduced damage.",
      "ingredients": [
        {
          "materialKey": "salvagedalloys",
          "name": "Salvaged Alloys",
          "size": 5
        },
        {
          "materialKey": "strangewakesolutions",
          "name": "Strange Wake Solutions",
          "size": 3
        },
        {
          "materialKey": "temperedalloys",
          "name": "Tempered Alloys",
          "size": 5
        }
      ]
    },
    {
      "key": "special_smart_rounds",
      "id": 25,
      "name": "Smart rounds",
      "description": "Friend or foe targeting upgrade that causes rounds to self-destruct before damaging ships that are not currently targeted.",
      "ingredients": [
        {
          "materialKey": "decodedemissiondata",
          "name": "Decoded Emission Data",
          "size": 3
        },
        {
          "materialKey": "mechanicalscrap",
          "name": "Mechanical Scrap",
          "size": 5
        },
        {
          "materialKey": "scandatabanks",
          "name": "Classified Scan Databanks",
          "size": 3
        },
        {
          "materialKey": "securityfirmwarepatch",
          "name": "Security Firmware Patch",
          "size": 3
        }
      ]
    },
    {
      "key": "special_shield_lightweight",
      "id": 113,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 1
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "wornshieldemitters",
          "name": "Worn Shield Emitters",
          "size": 5
        }
      ]
    },
    {
      "key": "special_engine_lightweight",
      "id": 118,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 3
        },
        {
          "materialKey": "iron",
          "name": "Iron",
          "size": 5
        },
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 1
        }
      ]
    },
    {
      "key": "special_fsd_lightweight",
      "id": 122,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "atypicaldisruptedwakeechoes",
          "name": "Atypical Disrupted Wake Echoes",
          "size": 5
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 3
        },
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 1
        }
      ]
    },
    {
      "key": "special_powerplant_lightweight",
      "id": 127,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "gridresistors",
          "name": "Grid Resistors",
          "size": 5
        },
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 1
        },
        {
          "materialKey": "vanadium",
          "name": "Vanadium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_powerdistributor_lightweight",
      "id": 132,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        },
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 1
        }
      ]
    },
    {
      "key": "special_shieldcell_lightweight",
      "id": 137,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "chemicalstorageunits",
          "name": "Chemical Storage Units",
          "size": 5
        },
        {
          "materialKey": "chromium",
          "name": "Chromium",
          "size": 3
        },
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 1
        }
      ]
    },
    {
      "key": "special_weapon_lightweight",
      "id": 142,
      "name": "Stripped Down",
      "description": "Key components replaced with versions crafted from lightweight materials and all extraneous parts removed entirely to reduce mass.",
      "ingredients": [
        {
          "materialKey": "carbon",
          "name": "Carbon",
          "size": 3
        },
        {
          "materialKey": "salvagedalloys",
          "name": "Salvaged Alloys",
          "size": 5
        },
        {
          "materialKey": "tin",
          "name": "Tin",
          "size": 1
        }
      ]
    },
    {
      "key": "special_shieldbooster_chunky",
      "id": 156,
      "name": "Super Capacitors",
      "description": "Additional, advanced capacitors increases overall shield strength at the cost of damage resistance.",
      "ingredients": [
        {
          "materialKey": "cadmium",
          "name": "Cadmium",
          "size": 2
        },
        {
          "materialKey": "compactcomposites",
          "name": "Compact Composites",
          "size": 5
        },
        {
          "materialKey": "shielddensityreports",
          "name": "Untypical Shield Scans",
          "size": 3
        }
      ]
    },
    {
      "key": "special_powerdistributor_fast",
      "id": 129,
      "name": "Super Conduits",
      "description": "Advanced, oversized energy conduits increase the power distributor's charge rate at the cost of reduced maximum charge potential.",
      "ingredients": [
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        },
        {
          "materialKey": "securityfirmwarepatch",
          "name": "Security Firmware Patch",
          "size": 1
        }
      ]
    },
    {
      "key": "special_super_penetrator_cooled",
      "id": 101,
      "name": "Super Penetrator",
      "description": "Experimental munitions that are capable of penetrating and damaging all modules along its trajectory, at the cost of increased reload times.",
      "ingredients": [
        {
          "materialKey": "protolightalloys",
          "name": "Proto Light Alloys",
          "size": 3
        },
        {
          "materialKey": "refinedfocuscrystals",
          "name": "Refined Focus Crystals",
          "size": 3
        },
        {
          "materialKey": "shielddensityreports",
          "name": "Untypical Shield Scans",
          "size": 5
        },
        {
          "materialKey": "zirconium",
          "name": "Zirconium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_super_penetrator",
      "id": 26,
      "name": "Super penetrator (Legacy)",
      "description": "Experimental munitions that are capable of penetrating and damaging all modules along its trajectory, at the cost of increased reload times.",
      "ingredients": []
    },
    {
      "key": "special_lock_breaker",
      "id": 27,
      "name": "Target lock breaker",
      "description": "Experimental upgrade that breaks target lock on successful strikes.",
      "ingredients": [
        {
          "materialKey": "adaptiveencryptorscapture",
          "name": "Adaptive Encryptors Capture",
          "size": 1
        },
        {
          "materialKey": "securityfirmwarepatch",
          "name": "Security Firmware Patch",
          "size": 3
        },
        {
          "materialKey": "selenium",
          "name": "Selenium",
          "size": 5
        }
      ]
    },
    {
      "key": "special_thermal_cascade",
      "id": 28,
      "name": "Thermal cascade",
      "description": "Experimental munitions that interact with shields upon detonation, generating significant heat on the target.",
      "ingredients": [
        {
          "materialKey": "heatconductionwiring",
          "name": "Heat Conduction Wiring",
          "size": 5
        },
        {
          "materialKey": "highdensitycomposites",
          "name": "High Density Composites",
          "size": 3
        },
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 4
        },
        {
          "materialKey": "phosphorus",
          "name": "Phosphorus",
          "size": 5
        }
      ]
    },
    {
      "key": "special_thermal_conduit",
      "id": 29,
      "name": "Thermal conduit",
      "description": "Experimental upgrade that increases damage output based on heat level of the firing ship.",
      "ingredients": [
        {
          "materialKey": "heatdispersionplate",
          "name": "Heat Dispersion Plate",
          "size": 5
        },
        {
          "materialKey": "sulphur",
          "name": "Sulphur",
          "size": 5
        },
        {
          "materialKey": "temperedalloys",
          "name": "Tempered Alloys",
          "size": 5
        }
      ]
    },
    {
      "key": "special_thermalshock",
      "id": 31,
      "name": "Thermal shock",
      "description": "Articulated focus array designed to spread heat effectively. Strikes to shields and hull impart additional heat into the target.",
      "ingredients": [
        {
          "materialKey": "conductivecomponents",
          "name": "Conductive Components",
          "size": 3
        },
        {
          "materialKey": "heatresistantceramics",
          "name": "Heat Resistant Ceramics",
          "size": 3
        },
        {
          "materialKey": "tungsten",
          "name": "Tungsten",
          "size": 3
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 5
        }
      ]
    },
    {
      "key": "special_engine_cooled",
      "id": 114,
      "name": "Thermal Spread",
      "description": "Additional thermal conduits and radiator solutions integrated across the module help balance thermal load increase cooling potential at the cost of slight mass increase",
      "ingredients": [
        {
          "materialKey": "heatvanes",
          "name": "Heat Vanes",
          "size": 1
        },
        {
          "materialKey": "hybridcapacitors",
          "name": "Hybrid Capacitors",
          "size": 3
        },
        {
          "materialKey": "iron",
          "name": "Iron",
          "size": 5
        }
      ]
    },
    {
      "key": "special_fsd_cooled",
      "id": 123,
      "name": "Thermal Spread",
      "description": "Additional thermal conduits and radiator solutions integrated across the module help balance thermal load increase cooling potential.",
      "ingredients": [
        {
          "materialKey": "atypicaldisruptedwakeechoes",
          "name": "Atypical Disrupted Wake Echoes",
          "size": 5
        },
        {
          "materialKey": "galvanisingalloys",
          "name": "Galvanising Alloys",
          "size": 3
        },
        {
          "materialKey": "gridresistors",
          "name": "Grid Resistors",
          "size": 3
        },
        {
          "materialKey": "heatvanes",
          "name": "Heat Vanes",
          "size": 1
        }
      ]
    },
    {
      "key": "special_powerplant_cooled",
      "id": 125,
      "name": "Thermal Spread",
      "description": "Additional thermal conduits and radiator solutions integrated across the module help balance thermal load increase cooling potential.",
      "ingredients": [
        {
          "materialKey": "gridresistors",
          "name": "Grid Resistors",
          "size": 5
        },
        {
          "materialKey": "heatvanes",
          "name": "Heat Vanes",
          "size": 1
        },
        {
          "materialKey": "vanadium",
          "name": "Vanadium",
          "size": 3
        }
      ]
    },
    {
      "key": "special_thermal_vent",
      "id": 30,
      "name": "Thermal vent",
      "description": "Experimental upgrade that increases heat dissipation when successfully striking a target, at the cost of increased heat generation when missing.",
      "ingredients": [
        {
          "materialKey": "conductivecomponents",
          "name": "Conductive Components",
          "size": 3
        },
        {
          "materialKey": "precipitatedalloys",
          "name": "Precipitated Alloys",
          "size": 3
        },
        {
          "materialKey": "uncutfocuscrystals",
          "name": "Flawed Focus Crystals",
          "size": 5
        }
      ]
    },
    {
      "key": "special_shield_thermic",
      "id": 110,
      "name": "Thermo Block",
      "description": "Improved feedback protection and reinforced projection nodes increase resistance to thermal damage, at the cost of overall shield strength.",
      "ingredients": [
        {
          "materialKey": "anomalousbulkscandata",
          "name": "Anomalous Bulk Scan Data",
          "size": 5
        },
        {
          "materialKey": "conductiveceramics",
          "name": "Conductive Ceramics",
          "size": 3
        },
        {
          "materialKey": "heatvanes",
          "name": "Heat Vanes",
          "size": 3
        }
      ]
    },
    {
      "key": "special_shieldbooster_thermic",
      "id": 151,
      "name": "Thermo Block",
      "description": "Improved feedback protection and reinforced projection nodes increase resistance to thermal damage, at the cost of overall shield strength.",
      "ingredients": [
        {
          "materialKey": "anomalousbulkscandata",
          "name": "Anomalous Bulk Scan Data",
          "size": 5
        },
        {
          "materialKey": "conductiveceramics",
          "name": "Conductive Ceramics",
          "size": 3
        },
        {
          "materialKey": "heatvanes",
          "name": "Heat Vanes",
          "size": 3
        }
      ]
    }
  ]
}
